/**
 * Keyboard Navigation Detection
 * Adds 'using-keyboard' class to body when user navigates with keyboard
 * This allows us to show focus indicators only for keyboard users
 */

(function () {
    'use strict';

    let usingKeyboard = false;

    // Detect keyboard navigation
    document.addEventListener('keydown', function (e) {
        if (e.key === 'Tab') {
            usingKeyboard = true;
            document.body.classList.add('using-keyboard');
        }
    });

    // Detect mouse usage
    document.addEventListener('mousedown', function () {
        usingKeyboard = false;
        document.body.classList.remove('using-keyboard');
    });

    // Also detect touch
    document.addEventListener('touchstart', function () {
        usingKeyboard = false;
        document.body.classList.remove('using-keyboard');
    });

    // Announce dynamic content changes to screen readers
    window.announceToScreenReader = function (message, priority = 'polite') {
        const announcement = document.createElement('div');
        announcement.setAttribute('role', 'status');
        announcement.setAttribute('aria-live', priority);
        announcement.setAttribute('aria-atomic', 'true');
        announcement.className = 'sr-only';
        announcement.textContent = message;

        document.body.appendChild(announcement);

        // Remove after announcement
        setTimeout(() => {
            document.body.removeChild(announcement);
        }, 1000);
    };

    // Trap focus within modals
    window.trapFocus = function (element) {
        const focusableElements = element.querySelectorAll(
            'a[href], button:not([disabled]), textarea:not([disabled]), input:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])'
        );

        const firstFocusable = focusableElements[0];
        const lastFocusable = focusableElements[focusableElements.length - 1];

        element.addEventListener('keydown', function (e) {
            if (e.key !== 'Tab') return;

            if (e.shiftKey) {
                if (document.activeElement === firstFocusable) {
                    lastFocusable.focus();
                    e.preventDefault();
                }
            } else {
                if (document.activeElement === lastFocusable) {
                    firstFocusable.focus();
                    e.preventDefault();
                }
            }
        });

        // Focus first element
        if (firstFocusable) {
            firstFocusable.focus();
        }
    };

    // Escape key to close modals
    document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') {
            const openModals = document.querySelectorAll('.modal[aria-hidden="false"], [role="dialog"][aria-hidden="false"]');
            openModals.forEach(modal => {
                const closeButton = modal.querySelector('[data-modal-close], .modal__close, [aria-label*="Close"]');
                if (closeButton) {
                    closeButton.click();
                }
            });
        }
    });

})();
